module.exports = __webpack_public_path__ + "static/media/brutalHit.0f42b073.svg";